import type { BookingsOverviewData, Booking as DomainBooking } from '../../domain/types'
import type { BookingsOverviewAPIResponse } from '../types'
import { formatDestination, formatPeriod, getOptimizedImageUrl, isBookingCancelled, isBookingPast } from './utils'

export function mapPastBookings(
  apiBookings: BookingsOverviewAPIResponse,
): BookingsOverviewData['pastBookings'] {
  const result: Record<string, DomainBooking> = {}

  apiBookings
    .filter(booking => !isBookingCancelled(booking.status) && isBookingPast(booking.returnDate))
    .forEach((booking) => {
      const mapped: DomainBooking = {
        bookingNumber: booking.bookingNumber.toString(),
        accommodationName: booking.accommodationName,
        destination: formatDestination(booking.destinationInformation),
        period: formatPeriod(booking.departureDate, booking.returnDate),
        imageSrc: getOptimizedImageUrl(booking.imageSrc, 160),
        rawDepartureDate: booking.departureDate,
      }

      result[mapped.bookingNumber] = mapped
    })

  return result
}
